import { V_FORM_ENUM } from "@/CommonDP/VForm/utils";

const COMPONENT_ENUM = {
  TYPE: "jyht-table",
  LABEL: "动态表格"
};
export const schema = {
  group: V_FORM_ENUM.custom,
  type: COMPONENT_ENUM.TYPE,
  icon: "data-table",
  label: COMPONENT_ENUM.LABEL,
  formItemFlag: true,
  widgetList: [], // 容器内存放的组件列表，初始值必须为[]
  component: require("./widget.vue").default,
  options: {
    name: "",
    tableHeight: "600px", // 高度，百分比或像素
    tableWidth: "100%", // 宽度，百分比或像素宽度
    requiredHint: "",
    required: false,
    disabled: false,
    position: "",
    setting: "",
    relateId: "",
    rawRelateId: "", // 暂时为空（涉及到按钮权限问题）
    renderMode: 0, // 渲染模式
    tableBtnList: [], // 所有的按钮
    addBtnShowList: [], // 新增状态下按钮展示与否
    editBtnShowList: [], // 编辑状态下按钮展示与否
    checkBtnShowList: [], // 查看状态下按钮展示与否
    sublist: "",
    // --------
    onValidate: "",
    onMounted: "",
    onCreated: ""
  },
  setColumns({ sublist: relatedSubTable, relateId: relatedListPageId, renderMode }) {
    const json = {
      relatedSubTable,
      relatedListPageId,
      renderMode: renderMode === 0 ? "followMainForm" : "independence"
    };
    return {
      extAttributeJson: JSON.stringify(json)
    };
  },
  props() {
    return {
      setting: () => import("./setting.vue")
    };
  },
  // 事件名 :[事件参数]
  events() {
    return {
      onMounted: [],
      onChange: ["value"]
    };
  },
  getSFC: () => {
    return "<div></div>";
  },
  zh: {
    [COMPONENT_ENUM.TYPE]: {
      label: "标签名称"
    }
  }
};
